import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLHelper } from 'helpers/url.helper';
import { DataService } from '../data-service';

@Injectable()
export class PricingDataService extends DataService {

  /**
   *
   * @param parkingLotId
   * @param data {"mode": "raw", "raw": {"temporaryRates": [...]}}
   */
  addTemporaryRate(data: any): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.post("", { "parking-lots": "PARKING_LOT_ID", "rates": "temporary" }, "",
                     JSON.stringify(data), options);
  }

  /**
   *
   * @param parkingLotId
   * @param data {"mode": "raw", "raw": {"monthlyRates": [...]}}
   */
  addMonthlyRate(data: any): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.post("", { "parking-lots": "PARKING_LOT_ID", "rates": "monthly" }, "",
                     JSON.stringify(data), options);
  }

  /**
   *
   * @param parkingLotId
   * @param tempRateId
   */
  removeTemporaryRate(tempRateId: number): Promise<any> {
    return this.delete("", { "parking-lots": "PARKING_LOT_ID", "rates": "temporary" }, "/" + tempRateId);
  }

  /**
   *
   * @param parkingLotId
   * @param monthlyRateId
   */
  removeMonthlyRate(monthlyRateId: Array<any>): Promise<any> {
    let monthlyRateIdsFormat = monthlyRateId.map((data) => {
      return data.id;
    }).join(",");
    return this.delete("", { "parking-lots": "PARKING_LOT_ID", "rates": "monthly" }, "?ids=" + monthlyRateIdsFormat);
  }

  /**
   *
   * @param parkingLotId
   */
  getTemporaryRates(): Promise<any> {
    return this.get("", { "parking-lots": "PARKING_LOT_ID" }, "/rates?type=temporary");
  }

  /**
   *
   * @param parkingLotId
   */
  getMonthlyRates(options: any, searchFilter: any, searchCategory?: string): Promise<any> {
    options = options || {};
    options.query = options.query || {};
    options.query['query'] = URLHelper.buildGeneralSearchFilter(
      {'name': 'string'},
      searchFilter || '*');
    let url: string = URLHelper.buildQueryString('/rates/monthly/search?', options.query, '');
    if (searchCategory) url = url + `;(timeUnit==${searchCategory})`;
    return this.get("", { "parking-lots": "PARKING_LOT_ID" }, url + '&sort=createdDate,desc');
  }

  /**
   *
   * @param parkingLotId
   * @param tempRateId
   * @param data {"mode": "raw", "raw": {"rates":"1,2,3,4,5", "freePeriod":0, "flatRate":10, "flatRatePeriod":5,
                                         "haveFlatRate":true, "description": "test temp rate", "min": 1, "max": 5}}
   */
  updateTemporaryRate(tempRateId: number, data: any): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.put("", { "parking-lots": "PARKING_LOT_ID", "rates": "temporary" }, "/" + tempRateId,
                    JSON.stringify(data), options);
  }

  /**
   *
   * @param parkingLotId
   * @param monthlyRateId
   * @param data {"mode": "raw", "raw": {"listFee": null, "fee": 2550, "timePeriod": 2, "timeUnit": "Month",
                                         "startTime": null, "endTime": null}}
   */
  updateMonthlyRate(monthlyRateId: number, data: any): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.put("", { "parking-lots": "PARKING_LOT_ID", "rates": "monthly" }, "/" + monthlyRateId,
                    JSON.stringify(data), options);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data-services/pricing/pricing.service.ts